import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  Redirect,
  Route,
  RouteChildrenProps,
  RouteComponentProps,
  Switch,
} from 'react-router';
import DocumentValidation from '.';
import { EmbeddedModeGuard } from '../../components/Restrictors';
import { EditDocument } from '../../features/document-edit/EditDocument';
import {
  documentNeighborsRoute,
  NeighborsRoutes,
} from '../../features/document-neighbors';
import { useIsFeatureEnabled } from '../../features/feature-enablement/featureEnablement';
import { getEditModeUrl, parse } from '../../lib/url';
import {
  enterValidation,
  leaveValidation,
} from '../../redux/modules/ui/actions';

// Safety net for every direct navigation to the legacy `/edit` URL
// (bookmarks, `?from=` deep-links, `location.state.backlink`) once the
// splitting view flag is on.
export const EditModeEntry = (
  props: RouteComponentProps<{ annotationId: string }>
) => {
  const isSplitEnabled = useIsFeatureEnabled('mat-1949-splitting-view');
  const { match, location } = props;
  const annotationId = Number(match.params.annotationId);

  if (isSplitEnabled) {
    const target = getEditModeUrl(true, {
      id: annotationId,
      query: parse(location.search),
    });
    const [pathname, search] = target.split('?');

    return (
      <Redirect
        push={false}
        to={{
          pathname,
          search: search ? `?${search}` : '',
          state: location.state,
        }}
      />
    );
  }

  return <EditDocument />;
};

export const DocumentValidationRoutes = () => {
  const dispatch = useDispatch();
  // temporary replacement of onEnter action dispatching on route
  useEffect(() => {
    dispatch(enterValidation());
    return () => {
      dispatch(leaveValidation());
    };
  }, [dispatch]);

  // the user will always be defined under RequireAuth hence this flag should always be used within the scope of RequireAuth
  return (
    <EmbeddedModeGuard>
      <Switch>
        <Route
          path={[
            '/document/:annotationId/edit',
            '/embedded/document/:annotationId/edit',
          ]}
          render={props => <EditModeEntry {...props} />}
        />
        <Route path={documentNeighborsRoute()} component={NeighborsRoutes} />
        <Route>
          {(
            props: RouteChildrenProps<{
              annotationId?: string;
            }>
          ) => {
            return props.match?.params.annotationId ? (
              // @ts-expect-error
              <DocumentValidation {...props} />
            ) : (
              <Redirect to="/" />
            );
          }}
        </Route>
      </Switch>
    </EmbeddedModeGuard>
  );
};
